import { inject, Injectable } from '@angular/core';
import { Router, type CanActivate, type GuardResult } from '@angular/router';
import { EnvironmentService } from '@big-direkt/utils/environment';
import { UserService } from '../state/user.service';

@Injectable({ providedIn: 'any' })
export class UserAnonymousGuard implements CanActivate {
    private readonly userService = inject(UserService);
    private readonly router = inject(Router);
    private readonly environmentService = inject(EnvironmentService);

    public async canActivate(): Promise<GuardResult> {
        await this.userService.initializeAuthentication(); // Make sure it is initialized

        if (!this.userService.isAuthenticated()) {
            return true;
        }

        return this.router.parseUrl(this.environmentService.privatePath);
    }
}
